import api from './api';

const GradeService = {
  getAll: async (params = {}) => {
    const response = await api.get('/grades/', { params });
    // Se a resposta for um array direto (sem paginação), retorna como results
    return Array.isArray(response.data) ? { results: response.data } : response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/grades/${id}/`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/grades/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/grades/${id}/`, data);
    return response.data;
  },

  partialUpdate: async (id, data) => {
    const response = await api.patch(`/grades/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/grades/${id}/`);
    return response.data;
  }
};

export default GradeService;
